import React, { Component, Fragment } from "react";
import "./IntegrationsTargets.css";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { setModalMessage } from "../../store/actions/general";

import { APPLICATION_NAME } from "../../core/constants";

import Header from "../../components/CRM/Header";
import LimitedDynamicTable from "../../components/general/LimitedDynamicTable";
import Box from "../../components/general/Box";

import IntegrationsController from "../../controllers/IntegrationsController";
import CompanyUnitController from "../../controllers/CompanyUnitController";

import Button from "../../components/general/Button";
import InputGeneral from "../../components/general/InputGeneral";
// import InputArea from "../../components/general/InputArea";
import Select from "../../components/general/Select";
import MessageContent from "../../components/general/MessageContent";
import DropDown from "../../components/general/DropDown";
// import ButtonIcon from "../../components/general/ButtonIcon";

const integrationsController = new IntegrationsController();
const companyUnitController = new CompanyUnitController();

const initialState = {
    // starts table
    table: <Fragment></Fragment>,
    // end table

    selectIdPixel: null,
    showModalPixel: false,

    optionsStatus: [
        {
            value: 1,
            name: "Ativo"
        },
        {
            value: 2,
            name: "Inativo"
        }
    ],
    choosenStatus: null,

    optionsUnits: [],
    choosenUnit: null,

    optionsTargets: [],
    choosenTarget: null,

    idPixel: null,
    idPkPixel: null,
    
    posY: 300,
    posX: 300,
    widthDropDownMoreActions: 286,
    showDropDownMoreActions: false,
    buttonMore: null,
    header: null,

    disableButtonSaveCreateWhatsAppQuickMessages: false
}

class IntegrationsTargets extends Component
{
    state = {...initialState}
    
    componentDidMount = async () => 
    {
        document.title = `${APPLICATION_NAME} - Pixels`;
        let buttonMore = this.buttonMore;
        let header = this.header;
        
        await this.setState({buttonMore, header});

        await this.getTargets();
        await this.getCompanyUnits();
        await this.getLimitedDynamicTableForIntegrationsPixels();
    }

    componentDidUpdate = async (prevProps, prevState) => 
    {
        if (prevProps.hasPermissionsLoaded !== this.props.hasPermissionsLoaded) 
        {
            if (!this.props.permissions.integrations.toView) { this.props.history.push(`/activities`); }
        }
    }

    message = (type, message) =>
    {
        this.props.setModalMessage({show: true, type, message});
    }

    getCompanyUnits = async () =>
    {
        const response = await companyUnitController.get();
        const units = response.data.data;
        const data = [];
   
        for (const unit of units)
        {
            data.push({
                value: unit.UNT_ID_COMPANY_UNIT_ERP,
                name: unit.UNT_NAME
            })
        }

        await this.setState({ optionsUnits: data });
    }

    getTargets = async () =>
    {
        const response = await integrationsController.getTargets();
        const targets = response.data.data;

        const data = [];

        for (const target of targets)
        {
            data.push({
                name: target.name,
                value: target.id
            })
        }

        await this.setState({ optionsTargets: data });
    }

    getLimitedDynamicTableForIntegrationsPixels = async () =>
    {
        const response = await integrationsController.getPixels();
        const content = response.data.data;

        if (content?.length <= 0)
        {
            await this.createTableEmpty();
            return;
        }

        await this.setState({ optionsPixels: content })

        let header = [
            {
                name: "ID PIXEL",
                justify: "center"
            },
            {
                name: "Unidade",
                justify: "center"
            },
            {
                name: "Status",
                justify: "center"
            },
            {
                name: "Ações",
                justify: "right"
            }
        ];
        
        let body = [];

        content.forEach((item, i) => {
            body.push([
                {
                    name: item.name,
                    justify: "center"
                },
                {
                    name: item.unit_name,
                    justify: "center"
                },
                {
                    name: item.status === 1 ? "Ativo" : "Inativo",
                    justify: "center"
                },
                {
                    name: (
                        <i
                            className="fa fa-bars iconEditWhatsAppQuickMessages"
                            onClick={async (event) => {
                                const rect = event.currentTarget.getBoundingClientRect();
                                await this.setState({
                                    idPixel: item.pixel,
                                    choosenUnit: this.state.optionsUnits.find((e) => e.value === item.unit),
                                    choosenStatus: this.state.optionsStatus.find((e) => e.value === item.status),
                                    choosenTarget: this.state.optionsTargets.find((e) => e.value === item.target),
                                    selectIdPixel: item.id,
                                    posX: rect.left - 275,
                                    posY: rect.bottom + 5,
                                    showDropDownMoreActions: true,
                                });
                            }}
                        />
                    ),
                    justify: "right"
                }
            ])
        });
        
        let footer = [];

        await this.setState({ table:
            <LimitedDynamicTable
                classaditional="quickMessagesLimitedDynamicTableWhatsAppQuickMessages"
                header={header}
                body={body}
                footer={footer}
                config={{
                    columns: [
                       {
                            index: 0,
                            width: 25
                        },
                        {
                            index: 1,
                            width: 30
                        },
                        {
                            index: 2,
                            width: 25
                        },
                        {
                            index: 3,
                            width: 20
                        }
                    ]
                }}
            />
        })
    } 

    createTableEmpty = async () =>
    {
        let header = [
            {
                name: " ",
                justify: "center"
            },
            {
                name:  " ",
                justify: "center"
            },
            {
                name:  " ",
                justify: "center"
            }
        ];
        
        let body = [
            [
                {
                    name: "",
                    justify: "center"
                },
                {
                    name: "Não foi encontrado nenhum registro.",
                    justify: "center"
                },
                {
                    name: "",
                    justify: "center"
                }
            ]
        ];
        
        let footer = [];

        await this.setState({ table:
            <LimitedDynamicTable
                classaditional="quickMessagesLimitedDynamicTableWhatsAppQuickMessages"
                header={header}
                body={body}
                footer={footer}
                config={{
                    columns: [
                        {
                            index: 0,
                            width: 25
                        },
                        {
                            index: 1,
                            width: 50
                        },
                        {
                            index: 2,
                            width: 25
                        }
                    ]
                }}
            />
        })
    }

    savePixel = async () =>
    {
        if (this.state.idPixel === null || this.state.idPixel === "")
        {
            return this.message("error", "Preencha o campo obrigatório para continuar.");
        }

        if (this.state.selectIdPixel !== null)
        {
            const data = {
                id: this.state.selectIdPixel,
                pixel: parseInt(this.state.idPixel),
                unit: this.state.choosenUnit.value,
                status: this.state.choosenStatus.value,
                target: this.state.choosenTarget.value
            }
    
            await integrationsController.updatePixel(data); 
        }
        else
        {
            const data = {
                pixel: parseInt(this.state.idPixel),
                unit: this.state.choosenUnit.value,
                status: this.state.choosenStatus.value,
                target: this.state.choosenTarget.value
            }
    
            await integrationsController.createPixel(data); 
        }

        await this.setState({
            showModalPixel: false,
            idPixel: null,
            choosenUnit: null,
            choosenStatus: null,
            selectIdPixel: null,
        });

        await this.getLimitedDynamicTableForIntegrationsPixels();
    }

    openModalPixel = async () =>
    {
        await this.setState({ showModalPixel: true });
    }

    render ()
    {
        return (
            <Fragment>
                {
                    this.state.showModalPixel &&
                    <MessageContent
                        message_title={"Pixels"}
                        onClose={() => { this.setState({showModalPixel: false}); }}
                        show={this.state.showModalPixel}
                        message_type={"information"}
                        classaditional="boxModalMessageContentWhatsAppQuickMessages"
                    >
                        <div className="boxCreateWhatsAppQuickMessages">
                            <div className="row">
                                <InputGeneral 
                                    label={"Identificação"}
                                    placeholder="Digite o ID do Pixel..."
                                    mandatory={"true"}
                                    value={this.state.idPixel}
                                    onChange={(e) => { this.setState({ idPixel: e.target.value }); }}
                                />
                            </div>
                            <div className="row">
                                <Select
                                    label="Unidade"
                                    placeholder="Selecione uma unidade..."
                                    mandatory={"true"}
                                    options={this.state.optionsUnits}
                                    default={this.state.choosenUnit}
                                    onChange={(choosenUnit) => { this.setState({ choosenUnit }); }}
                                    withFieldSearch
                                />
                            </div>
                            <div className="row">
                                <Select
                                    withFieldSearch
                                    label="Página"
                                    placeholder="Selecione uma página..."
                                    mandatory={"true"}
                                    options={this.state.optionsTargets}
                                    default={this.state.choosenTarget}
                                    onChange={(choosenTarget) => { this.setState({ choosenTarget }); }}
                                />
                            </div>
                            <div className="row">
                                <Select
                                    label="Status"
                                    placeholder="Selecione uma status..."
                                    mandatory={"true"}
                                    options={this.state.optionsStatus}
                                    default={this.state.choosenStatus}
                                    onChange={(choosenStatus) => { this.setState({ choosenStatus }); }}
                                />
                            </div>
                            <span className="mandatoryInformationWhatsAppQuickMessages">(*) campos com preenchimento obrigatório.</span>
                            <div className="boxButtonsOfModalCreateWhatsAppQuickMessages">
                                <Button 
                                    name="cancelar"
                                    classaditional="buttonCancelCreateWhatsAppQuickMessages"
                                    onClick={() => {
                                        this.setState({ 
                                            showModalPixel: false,
                                        });
                                    }}
                                />
                                <Button 
                                    name={this.state.disableButtonSaveCreateWhatsAppQuickMessages ? "aguarde..." : "salvar"}
                                    disabled={this.state.disableButtonSaveCreateWhatsAppQuickMessages}
                                    classaditional="buttonSaveCreateWhatsAppQuickMessages"
                                    onClick={async () => {
                                        await this.setState({disableButtonSaveCreateWhatsAppQuickMessages: true});
                                        await this.savePixel();
                                        await this.setState({disableButtonSaveCreateWhatsAppQuickMessages: false});
                                    }}
                                />
                            </div>
                        </div>
                    </MessageContent>
                }
                {
                    this.state.showDropDownMoreActions &&
                    <DropDown
                        style={{
                            top: `${this.state.posY}px`,
                            left: `${this.state.posX}px`,
                            width: `${this.state.widthDropDownMoreActions}px`,
                        }}
                        onMouseLeave={() => this.setState({showDropDownMoreActions: false})}
                        classaditional="dropMoreActionsWhatsappQuickMessages"
                    >
                        {
                            this.props.permissions.integrations.toUpdate &&
                            <Fragment>
                                <Button
                                    classaditional="buttonMoreActionsWhatsappQuickMessages"
                                    icon="fa fa-edit iconEditWhatsAppQuickMessages"
                                    name="Editar Pixel"
                                    onClick={() => this.openModalPixel()}
                                />
                            </Fragment>
                        }
                    </DropDown>
                }
                <div className="whatsAppQuickMessages">
                    <Header title="Integrações - Pixels" classaditional="headerNavigationServiceQueue"/>
                    <div className="containerBodyWhatsAppQuickMessages">
                        <div className="col-12 boxHeaderWhatsAppQuickMessages">
                            <Box>
                                <h4>Pixels</h4>
                            </Box>
                        </div>
                        <div className="col-12 boxActionsWhatAppQuickMessages">
                            {
                                // this.props.permissions.integrations.toInsert &&
                                <div>
                                    <Button
                                        classaditional="buttonCreateWhatAppQuickMessages"
                                        name="novo pixel"
                                        icon="fa fa-code mr-2"
                                        onClick={() => { this.openModalPixel(); }}
                                    />
                                </div>
                            }
                        </div>
                        <div className="row no-gutters lineBodyWhatsAppQuickMessages">
                            <div className="col-12 columnBodyWhatsAppQuickMessages pl-md-2 pr-md-2">
                                <Box classaditional="boxWhatsAppQuickMessages">
                                    <div className="boxScroolManager">
                                        <div className="boxManagerWhatsAppQuickMessages">
                                            <div className="boxScroolTeam">
                                                <div>
                                                    {this.state.table}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

function mapStateToProps (state)
{
    const {user} = state.auth;
    const permissions = state.permissions;
    const {hasPermissionsLoaded} = permissions;

    return {
        user,
        permissions,
        hasPermissionsLoaded,
    }
}

function mapDispatchToProps (dispatch)
{
    return {
        setModalMessage (data)
        {
            //action creator -> action
            const action = setModalMessage(data);
            dispatch(action);
        },
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IntegrationsTargets));